module.exports = __webpack_public_path__ + "static/media/exist-testing-text.b8eb75ac.png";